import { Printbreak } from "../../../../../src/printbreak";
import { DenseTable } from "../../../../../src/specification";
import * as React from 'react';
export default {
  Printbreak,
  DenseTable,
  React
};